var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDataEcs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8333 7H12.1433C9.55333 7 7.52333 9.1 7.52333 11.6667L7.5 44.3333C7.5 46.9 9.55333 49 12.1433 49H44.8333C47.4 49 49.5 46.9 49.5 44.3333V11.6667C49.5 9.1 47.4 7 44.8333 7ZM44.8333 35H35.5C35.5 38.8733 32.35 42 28.5 42C24.65 42 21.5 38.8733 21.5 35H12.1433V11.6667H44.8333V35ZM37.8333 23.3333H33.1667V16.3333H23.8333V23.3333H19.1667L28.5 32.6667L37.8333 23.3333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDataEcs);
export default __webpack_public_path__ + "static/media/icon_data_ecs.93d52b87896f5caae6510807569fb7fe.svg";
export { ForwardRef as ReactComponent };